"use strict";
exports.__esModule = true;
exports.getMarkerId = exports.getPositionId = void 0;
exports.getPositionId = function (pin) { return pin.lat + "." + pin.lng; };
exports.getMarkerId = function (pin) { return pin.lat + "." + pin.lng + "-" + pin.popupActive; };
